<template>
    <div class="cart">
        <div class="shop_top"><shop-top :subnav_show="false" :change_color="true"></shop-top></div>

        <div class="cart_body">
            <div class="join_over width_center_1200">
                <div class="join_bzt">
                    <el-steps :active="0" simple>
                        <el-step title="我的购物车" icon="el-icon-shopping-cart-full"></el-step>
                        <el-step title="物流地址" icon="el-icon-map-location"></el-step>
                        <el-step title="选择支付" icon="el-icon-mouse"></el-step>
                        <el-step title="支付成功" icon="el-icon-check"></el-step>
                    </el-steps>
                </div>
            </div>
             <div class="width_center_1200" style="margin-top:20px; text-align: right;">
               <el-input v-model="search" placeholder="请输入商品名称查询" @input="handleChangeSearch" clearable @clear="clearSearch" style="width:200px; margin-left:20px;"></el-input>
               <el-button icon="el-icon-search" type="primary" native-type="submit" @click="Search" style="margin-left:20px;"> 查询 </el-button>
               <el-button icon="el-icon-refresh" type="primary" native-type="submit" @click="clearSearch" > 刷新购物车 </el-button>
             </div>
            <!-- @selection-change="handleSelectionChange" -->
            <div class="store_goods_all  width_center_1200">
                <div class="store_goods_all_store_info">
                    <el-table ref="multipleTable"
                                :data="list"
                                max-height="490"
                                style="width: 100%; margin-top:20px;"
                                @selection-change="handleSelectionChange"
                                row-key='id'
                                @select="changeSelect"
                                tooltip-effect="dark"
                                :row-class-name="tableRowClassName"
                                :summary-method="getSummaries"
                                :show-summary="false"
                                :header-cell-style="{background:'#f5f7fa',color:'#909399'}"
                                :header-cell-class-name="cellClass"
                                border>
                        <el-table-column type="selection" style="display:none" @change="changeSelect(scope.$index, scope.row)" :reserve-selection="true" :selectable='checkboxT' disabled='true' width="60" align="center" label="全选"></el-table-column>

                        <!-- <el-table-column label="ID" width="100" align="center" sortable prop="goodsId">
                            <template slot-scope="scope">
                                {{scope.row.id}}
                                <p>
                                    <el-tag size="mini" type="danger" v-if="scope.row.discountid == 3 && scope.row.promoId ">秒杀</el-tag>
                                    <el-tag size="mini" type="success" v-if="scope.row.discountid == 2 && scope.row.promoId ">特价</el-tag>
                                    <el-tag size="mini" type="danger" v-if="scope.row.discountid == 9 && scope.row.promoId ">专享</el-tag>
                                    <el-tag size="mini" type="warning" style="cursor: pointer;" v-if="scope.row.iscombo == true" @click="view_tc(scope.$index, scope.row)">套餐</el-tag>
                                    <el-tag size="mini" effect="dark" type="danger" v-if="scope.row.stock < scope.row.qty && scope.row.stock > 0">库存：{{scope.row.stock}}</el-tag>
                                    <el-tag size="mini" effect="dark" type="danger" v-else-if="scope.row.stock <= 0">库存不足</el-tag>
                                </p>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="图片" align="center" width="80" >
                            <template slot-scope="scope">
                                <el-popover placement="top-start" trigger="click" v-if="scope.row.img">
                                    <img :src="filePath + scope.row.img" style="max-width: 300px;height: auto">
                                    <img slot="reference" :src="filePath + scope.row.img" style="width: 40px;height: auto; cursor: pointer;">
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column label="商品名称" min-width="200px" align="center" sortable prop="spuName">
                            <template slot-scope="scope">
                                <p class="title" style="cursor: pointer;" @click="goGoodsInfo(scope.$index, scope.row)">{{scope.row.spuName}}
                                <span v-if="scope.row.oriPlace">({{scope.row.oriPlace}})</span></p>
                                <p class="ftitle" style="cursor: pointer;" @click="goGoodsInfo(scope.$index, scope.row)">{{scope.row.companyName}}</p>
                            </template>
                        </el-table-column>

                        <el-table-column label="规格" align="center" width="120"  sortable prop="batchno">
                            <!-- <template slot-scope="scope">{{scope.row.spec}}<span v-if="scope.row.brand">/{{scope.row.brand}}</span></template> -->
                            <template slot-scope="scope">
                                {{scope.row.spec}}<span v-if="scope.row.brand">/{{scope.row.brand}}</span>
                                <p>
                                    <el-tag size="mini" type="danger" v-if="scope.row.discountid == 3 && scope.row.promoId ">秒杀</el-tag>
                                    <el-tag size="mini" type="success" v-if="scope.row.discountid == 2 && scope.row.promoId ">特价</el-tag>
                                    <el-tag size="mini" type="danger" v-if="scope.row.discountid == 9 && scope.row.promoId ">专享</el-tag>
                                    <el-tag size="mini" type="warning" style="cursor: pointer;" v-if="scope.row.iscombo == true" @click="view_tc(scope.$index, scope.row)">套餐</el-tag>
                                    <el-tag size="mini" effect="dark" type="danger" v-if="scope.row.stock < scope.row.qty && scope.row.stock > 0">库存：{{scope.row.stock}}</el-tag>
                                    <el-tag size="mini" effect="dark" type="danger" v-else-if="scope.row.stock <= 0">库存不足</el-tag>
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column label="批号" align="center" width="100" sortable prop="batchno">
                            <template slot-scope="scope">{{scope.row.batchno}}
                            </template>
                        </el-table-column>
                        <el-table-column label="数量" align="center" width="130px" sortable prop="qty">
                            <template slot-scope="scope">
                                <el-input-number size="mini" :precision="0" v-if="scope.row.stock < scope.row.qty && scope.row.stock > 0" v-model="scope.row.qty" controls-position="right" :step="scope.row.miniQty" @change="handleChange(scope.$index, scope.row)" @on-change="handleChange(scope.$index, scope.row)" :min="scope.row.miniQty" :max="scope.row.qty"></el-input-number>
                                <el-input-number size="mini" :precision="0" v-else-if="scope.row.stock <= 0" :disabled="true" v-model="scope.row.qty" controls-position="right" :step="scope.row.miniQty" :min="scope.row.miniQty" :max="scope.row.qty"></el-input-number>
                                <el-input-number size="mini" :precision="0" v-else :disabled="scope.row.stock >= scope.row.qty?false:true" v-model="scope.row.qty" controls-position="right" :step="scope.row.miniQty" @change="handleChange(scope.$index, scope.row)" @on-change="handleChange(scope.$index, scope.row)" :min="scope.row.miniQty" :max="scope.row.stock"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="到手价" align="center" sortable prop="curPrice">
                            <template slot-scope="scope">
                                <span v-if="rate > 0 && scope.row.isCheck == true && scope.row.discountid != 3 && scope.row.discountid != 9 && scope.row.isSpecial == 0">{{scope.row.curPrice*rate*autoRate | money }}</span><!--全场-->
                                <span v-else-if="rate > 0 && scope.row.isCheck == true && scope.row.discountid != 3 && scope.row.discountid != 9  && scope.row.isSpecial == 1">{{scope.row.curPrice*rate*specialRate*autoRate | money}}</span><!--是专品-->
                                <span v-else>{{scope.row.curPrice | money }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="小计" align="center" sortable prop="purchaseMoney">
                            <template slot-scope="scope">
                                <span v-if="rate > 0 && scope.row.isCheck == true && scope.row.discountid != 3 && scope.row.discountid != 9 && scope.row.isSpecial == 0">{{scope.row.purchaseMoney*rate*autoRate | money}}</span><!--全场券-->
                                <span v-else-if="rate > 0 && scope.row.isCheck == true && scope.row.discountid != 3 && scope.row.discountid != 9  && scope.row.isSpecial == 1">{{scope.row.purchaseMoney*rate*specialRate*autoRate | money}}</span><!--是专品券-->
                                <span v-else>{{scope.row.purchaseMoney | money}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini"
                                        type="danger"
                                        icon="el-icon-delete"
                                        @click="handleDeleteBuycar(scope.$index, scope.row)">删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <div class="table-container width_center_1200" style="margin-top:20px;">
                <el-form :inline="true" :model="couponList" size="small" label-width="140px" v-if="couponList">
                    <el-form-item label="专品券：" prop="specialType">
                        <el-select :disabled="couponList.special && couponList.special.length > 0?false:true" clearable multiple placeholder="请选择专品券" v-model="special_list" @change="changeSpecial" @clear="clearSpecial">
                            <el-option
                            v-for="(item, index) in couponList.special"
                            :key="item.gainpromoId"
                            :label="item.lableText"
                            :disabled="item.disabled"
                            :value="index">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="全场券：" prop="globalType">
                        <el-select  
                            :disabled="couponList.global && couponList.global.length > 0?false:true"
                            v-model="global_list" 
                            clearable multiple :loading="isGlobalLoading"
                            placeholder="请选择全场券"
                            @change="changeGlobal" 
                            @clear="clearGlobal">
                            <el-option
                            v-for="(item, index) in couponList.global"
                            :key="item.gainpromoId"
                            :label="item.lableText"
                            :disabled="item.disabled"
                            :value="index">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="欣币：">
                        <el-select :disabled="couponList.virtual > 0?false:true" clearable placeholder="请选择欣币" v-model="virtual_list" @change="changeVirtual" @clear="clearVirtual">
                            <el-option
                            :key="couponList.virtual"
                            :label="couponList.virtual"
                            :value="`${couponList.virtual}|${couponList.virtualRate}`">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                </el-form>
            </div>


            <!--优惠券列表结束-->
            <div class="store_goods_list width_center_1200" style="margin-bottom: 30px;">
                <div class="store_goods_list_title">
                    <el-row>
                        <el-col :span="8" style="margin-top:8px;">
                            <el-checkbox :checked="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange(list)">{{selectAllText}}</el-checkbox>
                            <span class="separator"></span>
                            <div class="shopping-link" @click="removeGoodsList">批量删除</div>
                            <span class="separator"></span>
                            <a class="shopping-link" href="/goods/params/?keyword=" target="_blank"> 继续购物 </a>
                            <el-popover
                                placement="top-start"
                                title="优惠详情"
                                width="300"
                                trigger="hover" :disabled="showDisCounts">
                                <p v-if="showVirtualDisCounts">{{showVirtualDisCounts}}</p>
                                <p v-if="showCouponDiscounts"><span v-html="formattedText"></span></p>
                                <p v-if="specialDiscountName"><span v-html="formattedSpecialText"></span></p>
                                <p v-if="showAutoDiscounts">{{showAutoDiscounts}}</p>
                                <div slot="reference" class="shopping-link"><span class="separator"></span>优惠明细</div>
                            </el-popover>
                        </el-col>
                        <el-col :span="13" style="text-align:right;margin-top:2px;">
                            <div class="shopping-link">已选择<font color="#38A93C" style="margin:0 10px;">{{total_num}}</font>件商品</div>
                            <span class="separator" ></span>
                            

                            <div class="shopping-link">总价<span v-if="rate > 0" style="font-size:16px; margin:0 5px; color: #38A93C">￥{{total_price}},</span>

                                <span v-if="rate > 0 ">
                                    <span v-if="nowSpecialMoney > 0">
                                        (优惠后,不含运费)约2：
                                        <span  class="nowPrice">￥{{pay_money}}</span>
                                    </span>
                                    <span v-else>
                                        (优惠后,不含运费)约1：
                                        <span  class="nowPrice">￥{{(Number((total_price-seckillMoney) * rate * autoRate)+Number(seckillMoney)) | money }}</span>
                                    </span>
                                </span>

                                <span v-else class="nowPrice">￥{{total_price | money}}</span>

                            </div>
                        </el-col>
                        <el-col :span="3">
                            <div  class="topay" style="margin-left: 30px;" v-loading="loading" element-loading-text="请稍后" @click="to_create">结&nbsp;&nbsp;&nbsp;&nbsp;算</div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>

        <shop-foot></shop-foot>
        <!-- vue 回到顶部 -->
         <ShopMbar></ShopMbar>

        <!-- 套餐明细 -->
        <el-dialog title="套餐明细"
        :visible.sync="dialogVisibleCombo"
        width="60%">
            <el-table
                ref="tclistTable"
                :data="tclist"
                :row-class-name="tableRowClassName2"
                style="width: 100%;margin-top: 10px" border>
                <el-table-column label="商品ID" width="100" align="center">
                    <template slot-scope="scope">{{scope.row.id}}</template>
                </el-table-column>
                <el-table-column label="商品图片" width="100px;"  align="center">
                    <template slot-scope="scope">
                        <el-popover placement="top-start" trigger="click">
                            <img :src="filePath + scope.row.imgs" style="max-width: 500px;height: auto">
                            <img v-if="scope.row.imgs" slot="reference" :src="filePath + scope.row.imgs" style="width: 50px;height: auto; cursor: pointer;">
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="商品信息">
                    <template slot-scope="scope">
                        <p style="margin:5px !important;">{{scope.row.name}}</p>
                        <p style="margin:5px !important;"><el-tag type="success" size="mini">批号:{{scope.row.batchno}}</el-tag>&nbsp;&nbsp;<el-tag  size="mini">规格:{{scope.row.spec}}</el-tag>&nbsp;&nbsp;<el-tag type="info"  size="mini">{{scope.row.mfrsName}}</el-tag></p>
                    </template>
                </el-table-column>
                <el-table-column label="售价" width="120" align="center">
                    <template slot-scope="scope"><span v-if="scope.row.price">￥{{scope.row.price}}</span></template>
                </el-table-column>
                <el-table-column label="数量" width="90" align="center">
                    <template slot-scope="scope">
                        {{scope.row.qty}}
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import ShopTop from "@/components/home/public/head.vue"
import ShopFoot from "@/components/home/public/shop_foot.vue"
import ShopMbar from "@/components/home/public/mui_mbar_tabs.vue"  //右侧固定快捷导航
import {formatDate} from '@/utils/date';
const defaultListQuery = {
    pageNum: 1,
    pageSize: 10,
    name:null,
    starttime:null,
    endtime:null,
    customerId:null,
};
export default {
    components: {
        ShopTop,
        ShopFoot,
        ShopMbar, //右侧固定快捷导航
    },
    inject:['reload'],
    props: {},
    data() {
        return {
            listQuery: Object.assign({}, defaultListQuery), 
            fullGiftVal: null,//满赠选中
            tableData: [],//满赠数据
            dialogFullGiftloading:false,//控制满赠加载
            dialogVisibleHistory:false,
            dialogFullGift: false, //满赠弹出框控制
            checkAll:false,
            checkAll2:false,
            checkStore:[],
            isIndeterminate:false,
            list:[],
            hlist:[],
            createTime:[],
            ulist:[], //采购单
            multipleSelection:[],
            store_list_check:[],
            total_price:0, // 统计价格
            total_num:0, // 统计数量
            now_money:0, //去掉秒杀后金额
            seckillMoney:0, //秒杀价格
            pay_money:0,    //支付金额约
            filePath:null,
            spuid:null,
            iscombo:false,
            dialogVisibleCombo:false,
            dialogSettlementOne:false,
            dialogSettlementTwo:false,
            dialogVisibleUpload:false,
            tclist:[],
            search:'',
            searchData: [],
            rows:{
                shopcarid:null,
                goodsId:null,
                qty:null,
                price:null,
                discountid:null,
            },
            listLoading: false,
            listLoadings: false,
            loading:false,
            show:true,
            cartsId:null,
            coupon_list:null, //优惠券列表
            global_list:[],   //全场券
            special_list:[],   //专品券
            virtual_list:[],   //虚拟货币     
            couponList:[],    //可用优惠券列表
            coupon:null,
            showCouponMoney: false, //显示优惠金额
            activeName: 'first', //tab切换
            active: 1,
            express:0,      //配送方式
            remark:'',      // 备注
            coupon_money:0,   //优惠金额
            selectCouponId:0,    //默认优惠券ID
            drawer: false,
            direction: 'rtl',
            size:'450px',
            promoId:0,
            virtualMoney:0,
            visitNum:0,
            number:1,
            allSelect: false, //默认全选
            rate:0, //优惠券折扣率
            isSpecial:0, //专品
            selectAllText:'全选',
            searchNum:0, //搜索次数
            nowSpecialMoney:0, //选择专品券后价
            oldSpecialMoney:0, //选择专品券后原价
            selectcarId:0,     //库存大于最小购买量ID
            stockLow:0,        //库存不足商品
            allCartId:0,       //全部ID
            autoRate:1.00, //全场折扣/满减的折扣率
            fullMoney: 0, //全场满减的面值,
            showCouponDiscounts: null, //优惠券优惠展示
            showAutoDiscounts: null, //自动优惠展示
            showVirtualDisCounts: null, //欣币优惠展示
            showDisCounts: true,
            specialDiscountName:null,//专品优惠展示
            isGlobalLoading:false,
            globalRate:1,
            virtual_Rate:1,
            specialRate:1,
            globalPromId:'',
            specialPromId:'',
            markSpecialCoupon:0,
            markGlobalCoupon:0,
            markVirtual:0,
            globalMarkVirtual:0,
            specialMarkVirtual:0,
            importProductsVisiable: false
        };
    },
    filters: {
        money(val) {
            if(isNaN(val)) {
            val = "0";  
            } 
            let sign = (val == (val = Math.abs(val)));
            val = Math.floor(val*100+0.50000000001);
            let cents = val%100;
            val = Math.floor(val/100).toString();
            if(cents<10) {
            cents = "0" + cents
            }
            for (var i = 0; i < Math.floor((val.length-(1+i))/3); i++) {
                val = val.substring(0,val.length-(4*i+3))+',' + val.substring(val.length-(4*i+3));
            }
            return (((sign)?'':'-') + val + '.' + cents);
        },
        formatDate(time) {
            let date = new Date(time);
            if(time===undefined||time===null||time===''){
                return '暂无';
            }else{
                return formatDate(date, 'yyyy-MM-dd');
            }
        },
        formatCreateTime(time) {
            let date = new Date(time);
            if(time===undefined||time===null||time===''){
            return '暂无';
            }else{
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
            }
        },
    },
    watch: {},
    computed: {
        formattedText() {
            if(this.showCouponDiscounts){
                return this.showCouponDiscounts.replace(/\n/g, "<br>");
            } else {
                return '';
            }
        },
        formattedSpecialText(){
            if(this.specialDiscountName){
                return this.specialDiscountName.replace(/\n/g, "<br>");
            } else {
                return '';
            }
        }
    },
    mounted: function() {
    },
    methods: {
        //去商品详情
        goGoodsInfo(index,row){
            let url = '/goods/info/' + row.goodsId + '?v=' + this.version
            window.open(url);
        },

        get_user_info:function(){
            this.$get(this.$api.homeGetUserInfo,{platId:this.$platId}).then(res=>{
                if(res.code == 200){
                    this.userInfo = res.data;
                    this.userInfo.nowTime =  Date.parse(new Date()) / 1000;
                    this.userInfo.isLogin = true;
                    localStorage.setItem('userInfo',JSON.stringify(this.userInfo));
                    if(res.data.themeId != ''){
                        localStorage.setItem('themeId',res.data.themeId);
                    }
                }else if(res.code == 401){
                    this.$router.push('/user/login/');
                }else{
                    this.$router.push('/user/login/');
                }
            });
        },

        //附件路径
        filepath:function(){ 
             this.$get(this.$api.filepath,{platId:this.$platId}).then(res=>{
                this.filePath = res.data[0].config;
            });
        },

        //购物车列表
        get_cart_list:function(){
            this.listLoadings = true;
            this.$get(this.$api.homeGetCartList,{platId:this.$platId}).then(res=>{
                 this.start = new Date().getTime();
                if(res.code == 200){
                    if(res.data && res.data.length != 0){
                        if(res.data[0]){
                            this.listLoadings = false;
                        }
                        
                        res.data[0].forEach((item,index)=>{
                            item.max = item.qty;
                            item.num = index+1;
                            if(item.stock < item.miniQty){
                                item.isCheck = false
                            }
                            item.isSpecial = 0; //默认不是专品
                            item.purchaseMoney = Number(item.max)*Number(item.curPrice).toFixed(2);
                            if (item.isCheck == true) {
                                 this.$refs.multipleTable.toggleRowSelection(item, true);
                            }
                        });

                        //默认选中ID
                        let selectCheck = [];
                        let stockLow = [];
                        res.data[0].map((res)=>{
                            if(res.isCheck == true && res.stock >= res.miniQty){
                                selectCheck.push(res.id);
                            }
                            if(res.stock < res.miniQty){
                                //库存不足商品
                                stockLow.push(res.id);
                            }
                        });

                        this.separate_id = selectCheck; //选中购物车ID
                        this.isCheckLength = selectCheck.length; //选中数据
                        this.stockLow = stockLow;

                        //无选中数据优惠券,订单金额还原
                        if(this.isCheckLength == 0){
                            this.couponList = [];
                            this.special_list = [];
                            this.global_list = [];
                            this.virtual_list = [];
                            this.gainpromId = 0;
                            this.rate = 0;
                            this.discountMoney = 0;
                            this.total_price = 0;
                            this.nowSpecialMoney = 0;
                            this.oldSpecialMoney = 0;
                            this.checkAll = false;
                            this.total_num = 0;
                        }

                        this.list = res.data[0];
                        if(this.isCheckLength != this.list.length - this.stockLow.length || this.isCheckLength == 0){
                            this.selectAllText = '全选';
                            this.isIndeterminate = false;
                            this.checkAll = false;
                        }else{
                            this.selectAllText = '全选';
                            this.isIndeterminate = true;
                            this.checkAll = true;
                        }
                        this.sum_price();
                        this.listLoading = false;
                    }else{
                        this.checkAll = false;
                        this.listLoading = false;
                        this.list = [];
                        this.couponList = [];
                        this.special_list = [];
                        this.global_list = [];
                        this.virtual_list = [];
                        this.gainpromId = 0;
                        this.rate = 0;
                        this.discountMoney = 0;
                        this.total_price = 0;
                        this.cartsId = null
                    }

                }else if(res.code == 401){
                    this.$message.error(res.message);
                    localStorage.removeItem('token');
                    localStorage.removeItem('userInfo');        //用户信息
                    localStorage.removeItem('goodsCategory');   //栏目分类
                    localStorage.removeItem('column_list');     //底部菜单
                    localStorage.removeItem('popup_num');       //弹窗广告
                    localStorage.removeItem('serviceInfo');     //清除专属客服专属业务员
                    localStorage.removeItem('token');           //清除token
                    localStorage.removeItem('discount_rate');   //清除折扣率
                    this.$router.push('/user/login/');
                }else{
                    this.$message.error(res.message);
                }
                       
            }).catch(err=>{
                this.list = [];
                this.couponList = [];
                this.special_list = [];
                this.global_list = [];
                this.virtual_list = [];
                this.gainpromId = 0;
                this.rate = 0;
                this.discountMoney = 0;
                this.total_price = 0;
            })
        },

        //统计
        getSummaries(param) {
            const { columns, data } = param;
            const sums = []; //声明变量
            columns.forEach((column, index) => {
                if (index === 1) {
                    sums[index] = '订单合计';//可更改合计行的名称
                    return;
                }
                const values = data.map(item => {
                    return Number(item[column.property])//property为表头的prop值
                });
                if (column.property == "purchaseMoney") {  //需要显示和合计纵列 // column.property == "curPrice"  //需要显示和合计纵列
                    // every() 方法用于检测values数组所有元素是否都符合指定条件（通过函数提供）
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);//Number转换为数值
                            // let sum =Number(Number(prev) + Number(curr)).toFixed(2);//toFixed(2)数据项保留两位小数
                            let sum = this.total_price;
                            if (!isNaN(value)) {
                                return sum;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] += '元';//给合计项添加单位MW
                    } else {
                        sums[index] = '';
                    }
                }
            });
            return sums;
        },

        //库存不足禁选
        checkboxT(row,index){
            if(row.stock > 0){
                return 1;
            }else{
                return 0;
            }
        },

        //库存不足提示
        tableRowClassName({row, rowIndex}) {
            if (row.stock < row.qty) {
                return 'warning-row';
            }
            return '';
        },

        //隐藏table全选
		cellClass(row){
            if (row.columnIndex == 0) {
                return 'DisableSelection'
            }
        },

         //修改购物车选中状态,单选
        changeSelect(selection, row){
            this.listLoading = true
            if(row.isCheck == true){
                this.isCheck = false
            }else{
                this.isCheck = true
            }

            this.$put(this.$api.checkShopCarInfo,{
                ids:row.id,
                platId:this.$platId,
                customerId:this.userInfo.company,
                isCheck:this.isCheck,
            }).then(res=>{
                if(res.code == 200){
                    //选中
                    if(this.isCheck == true){
                        this.list.forEach((v,i)=>{
                            if(row.id == v.id && row.stock >= row.miniQty){
                                row.isCheck = true
                            }
                        });
                        this.sum_price();
                    }else{
                        //取消选中ID
                        let brr = []; 
                        this.list.forEach((v,i)=>{
                            if(row.id == v.id){
                                row.isCheck = false;
                                brr.push(i); //当前选中ID在list索引
                            }
                        });
                        this.list[brr].isCheck = false;
                        this.sum_price();
                    }
                }else{
                    this.$message.error(res.message);
                }
                this.listLoading = false
            }).catch(err=>{
                this.listLoading = false
            })

        },

        handleSelectionChange(val){
            if(this.multipleSelection.length != this.isCheckLength){
                //默认清空优惠后重新赋值
                this.special_list = [];
                this.global_list = [];
                this.virtual_list = [];
                this.gainpromId = 0;
                this.rate = 0;
                this.discountMoney = 0;
                this.globalPromId="";
                this.specialPromId="";
                return;
            }
            this.multipleSelection = val;
            //根据选择计算总金额
            // this.isIndeterminate = this.multipleSelection.length > 0 && this.multipleSelection.length < this.list.length;

            this.checkAll = this.multipleSelection.length === this.isCheckLength;

            //获取订单金额
            if(this.multipleSelection.length){
                let count = 0; //订单金额
                let separate_id = []; //已选购物车ID
                let seckillId = []; //秒杀ID
                let seckillMoney = 0; //秒杀金额
                this.total_num = this.multipleSelection.length;
                //订单金额统计
                this.multipleSelection.map((res)=>{
                    count = count + res.purchaseMoney;
                    separate_id.push(res.id); //购物车ID
                });
                this.total_price = count.toFixed(2); 
                this.cartsId = separate_id.join(',');
                this.separate_id = separate_id;
                    
                //秒杀金额统计
                this.multipleSelection.map((res)=>{
                    // if(!this.$isEmpty(res.isCheck) && res.isCheck == true && res.discountid == '3'){
                    if(res.discountid == '3' || res.discountid == '9'){
                        seckillMoney += (res.qty*res.curPrice);
                        //获取已选择秒杀购物车ID
                        let strId = res.id;
                        seckillId.push(strId);
                    }
                });
                this.seckillId = seckillId.join(',');   //已选择秒杀ID
                this.seckillMoney = seckillMoney.toFixed(2);       
            }else{
                this.total_price = 0;
                this.seckillMoney = 0;
                this.total_num = 0;
            }


            if(this.multipleSelection.length == this.isCheckLength){
                // this.listLoading = true;
                setTimeout(()=>{
                    this.getCouponsToOrdersList(true); //根据已选择信息获取优惠券列表 
                },50);

            }
        },

        //搜索
        Search() {
            var search = this.search;
            if (search) {
                this.list = this.list.filter(function(spuName) {
                    return Object.keys(spuName).some(function(key) {
                        return (
                            String(spuName[key])
                            // toLowerCase() 方法用于把字符串转换为小写。
                            .toLowerCase()
                            // indexOf() 方法可返回某个指定的字符串值在字符串中首次出现的位置。
                            .indexOf(search) > -1
                        );
                    });
                });
            }
        },

        //重置搜索
        clearSearch(){
            this.search = [];
            this.get_cart_list();
        },

        //监听搜索输入
        handleChangeSearch:function(info){
            if(info == ''){
                this.get_cart_list();
            }
        },
        
        // checkbox 全选选择
        handleCheckAllChange:function(rows){
            this.listLoading = true
            //获取全部购物车列表ID
            let separate_id = [];
            this.list.forEach(item=>{
                if(item.stock >= item.miniQty){
                    separate_id.push(item.id);
                    this.separate_id = separate_id;
                    this.selectcarId = separate_id; //库存大于最小购买量的ID
                    this.cartsId = separate_id.join(',');
                }
            });

            this.getSelectChangeAll();
            if(this.checkAll == false){
                this.special_list = [];
                this.global_list = [];
                this.virtual_list = [];
                this.gainpromId = 0;
                this.rate = 0;
                this.discountMoney = 0;
                this.total_price = 0;
            }
        },

        //全选、取消全选
        getSelectChangeAll(){
            this.checkAll2 = this.checkAll;
            this.$put(this.$api.checkShopCarInfo,{
                ids:this.cartsId,
                platId:this.$platId,
                customerId:this.userInfo.company,
                isCheck:this.checkAll,
            }).then(res=>{
                if(res.code == 200){
                    if(this.checkAll2 == true){
                        this.checkAll = true;
                        this.list.forEach(item=>{
                            if(item.stock >= item.miniQty){
                                item.isCheck = true;
                                this.$refs.multipleTable.toggleRowSelection(item, true);
                            }else{
                                item.isCheck = false;
                                this.$refs.multipleTable.toggleRowSelection(item, false);
                            }

                        });
                        this.sum_price();
                    }else{
                        this.list.forEach(item=>{
                            item.isCheck = false;
                            this.$refs.multipleTable.toggleRowSelection(item, false);
                        });
                        this.checkAll = false;
                        this.total_num = 0;
                        this.couponList = []
                        this.special_list = [];
                        this.global_list = [];
                        this.virtual_list = [];
                        this.gainpromId = 0;
                        this.rate = 0;
                        this.discountMoney = 0;
                        this.total_price = 0;
                        this.seckillMoney = 0;
                        this.cartsId = [];
                        this.separate_id = [];
                    }
                }else{
                    this.$message.error(res.message);
                }
                this.listLoading = false;
            }).catch(err=>{
                this.listLoading = false
            })
        },

        //套餐明细
        view_tc:function(index,row){
            this.spuid = row.spuid;
            if(this.spuid){
            this.dialogVisibleCombo = true;
            this.$get(this.$api.getGoodsDetails + this.spuid,{ platId:this.$platId }).then(res=>{
                if(res.code == 200){
                    if(res.data != null){
                        this.tclist = res.data;
                    }
                }
            });
            }
        },

        // 单个购物车删除
        handleDeleteBuycar:function(index,row){
            this.$post(this.$api.homeDelCart,{"params":{id:[row.id]},platId:this.$platId,companyId:this.userInfo.company,salerId:this.userInfo.id}).then(res=>{
                if(res.code == 200){
                    this.get_cart_count();
                    this.get_cart_list();
                    // this.sum_price();
                    return this.$message.success(res.message);
                }else{
                    return this.$message.error(res.message);
                }
                
            }).catch(err=>{
                // this.$message.error(err.message);
            })
        },
        
        //购物车数量
        get_cart_count:function(){
            this.$get(this.$api.homeGetCartCount,{platId:this.$platId}).then(res=>{
                this.cart_change = res.data
            });
        },

        //批量删除
        removeGoodsList() {
            //是否全部删除
            if(this.checkAll == true){
                this.deleteId = this.allCartId
            }else{
                this.deleteId = this.separate_id;
            }
            if(this.deleteId.length == 0){
                return this.$message.error('请选择购物车产品!');
            }
            if(this.list.length <= 0){
                return this.$message.error('购物车没有商品!');
            }
            this.$confirm('是否要删除购物车商品?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$post(this.$api.homeDelCart,{"params":{id:this.deleteId},platId:this.$platId,companyId:this.userInfo.company,salerId:this.userInfo.id}).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.message);
                        this.reload();
                    }else{
                        this.$message.error(res.message);
                        this.reload();
                    }
                }).catch(err=>{
                    this.$message.error(err.message);
                })
            }).catch(err => {});
        },

        sum_price:function(){
            let total_price = 0; //订单金额
            let separate_id = []; //已选购物车ID
            let allCartId = [];   //全部购物车ID
            let seckillId = []; //秒杀ID
            let seckillMoney = 0; //秒杀金额

            if(this.list.length){
                //统计已选订单金额
                this.list.forEach(item=>{
                    if(item.isCheck == true && item.stock >= item.miniQty){
                        total_price += (item.qty*item.curPrice); //已选订单金额
                        separate_id.push(item.id);               //已选购物车ID
                    }
                    allCartId.push(item.id);               //全部ID
                    this.cartsId = separate_id.join(',');  //选中ID
                    this.separate_id = separate_id;        //选中购物车ID
                    this.allCartId = allCartId;            //全部ID
                });

                //无选中数据优惠券,订单金额还原
                if(this.separate_id.length == 0){
                    this.couponList = [];
                    this.special_list = [];
                    this.global_list = [];
                    this.virtual_list = [];
                    this.gainpromId = 0;
                    this.rate = 0;
                    this.discountMoney = 0;
                    this.total_price = 0;
                    this.nowSpecialMoney = 0;
                    this.oldSpecialMoney = 0;
                    this.checkAll = false;
                    this.total_num = 0;
                }
                //获取秒杀金额统计
                this.list.forEach(item=>{
                    if(item.isCheck == true && (item.discountid == '3' || item.discountid == '9') && item.stock >= item.miniQty){
                        seckillMoney += (item.qty*item.curPrice);   //已选秒杀金额
                    }
                    if(item.isCheck == true && (item.discountid == '2' || item.discountid == '3' || item.discountid == '9') && item.stock >= item.miniQty){
                        seckillId.push(item.id);                    //已选秒杀ID
                    }
                });

                //默认选中ID
                let selectCheck = [];
                let stockLow = [];
                this.list.map((res)=>{
                    //已选中商品
                    if(res.isCheck == true && res.stock >= res.miniQty){
                        selectCheck.push(res.id);
                    }
                    if(res.stock < res.miniQty){
                        //库存不足商品
                        stockLow.push(res.id);
                    }
                });

                this.isCheckLength = selectCheck.length; //选中数据
                this.stockLow = stockLow;                //库存不足数据
                if(this.isCheckLength != this.list.length - this.stockLow.length){
                    this.selectAllText = '全选';
                    this.isIndeterminate = false;
                    this.checkAll = false;
                }else{
                    this.selectAllText = '全选';
                    this.isIndeterminate = true;
                    this.checkAll = true;
                }

                this.seckillId = seckillId.join(',');
                this.total_price = total_price.toFixed(2);
                this.pay_money = total_price.toFixed(2);
                this.total_num = separate_id.length;
                this.seckillMoney = seckillMoney.toFixed(2);
                if(this.total_price > 0){
                    setTimeout(()=>{
                        this.getCouponsToOrdersList(true); //根据已选择信息获取优惠券列表 
                    },100);
                }
            }
        },

        // 下一步选择收货地址创建订单
        // to_create:function(){
        //     let chose_cart = [];
        //     if(this.cart_list.length){
        //         this.cart_list.forEach(res=>{
        //             if(res !== null){
        //                 res.forEach(goodsRes=>{
        //                     if(!this.$isEmpty(goodsRes.check) && goodsRes.check == true){
        //                         let str = goodsRes.id;
        //                         chose_cart.push(str);
        //                     }
        //                 });
        //             }

        //         });
        //     }
        //     if(chose_cart.length<=0){
        //         return this.$message.error('请选择购物车产品！');
        //     }
        //     let cart_str = chose_cart.join(',');
        //     this.$router.push("/order/create_order/1/"+cart_str);
        // },

        // 下一步创建订单
        to_create:function(){
            if(this.separate_id && this.separate_id.length > 0){
                this.loading = true;
                this.create_order();
            }else{
                return this.$message.error('请选择购物车产品!');
            }

            // this.$router.push("/order/create_order/1/"+cart_str);
        },

        create_order:function(){
            let that = this;
            //根据platid和总金额，获取满赠
            this.$get(this.$api.GetFullgift, {
                platId: this.$platId,
                pageSize:100,
                money:this.pay_money,
                customer_id:this.userInfo.company,
                type:'new1'
                // money: this.total_price
            }).then((res) => {
                this.dialogFullGiftloading = true;
                res.data.list.sort(function(a,b){
                    return b.total-a.total
                })
                if(res.data.list.length>0){
                    for(let i=0;i<res.data.list.length;i++){
                        //循环，默认选中一个满赠商品，前提是库存>0
                        if(res.data.list[i].total>0){
                            //   console.log(i);
                            this.fullGiftVal = res.data.list[i]
                            this.dialogFullGift = true;
                            this.dialogFullGiftloading = false
                            break;
                        }
                        if(i+1==res.data.list.length){
                            if(res.data.list[i].total<=0){
                                this.createOrder();
                            }
                        }
                    }

                    that.tableData = res.data.list;
                    that.dialogFullGiftloading = false
                }else{
                    this.createOrder();
                }
            }).catch((err)=>{
                this.createOrder();
            });
            // this.beforePlaceOrde();
            // console.log('123');
        },
        createOrder:function(){
            if(this.$isEmpty(localStorage.getItem('token'))){
                this.$message.error('请先登录!');
                return this.$router.push('/user/login');
            }
            //生成订单并支付
            if(this.pay_money <= 0){
                this.$message.error('订单金额有误，即将返回购物车');
                this.loading = false;
                this.reload();
                return 
            }

            if(this.seckillId.length > 0){
                    let json = {}
                if(this.tableData.length>0 && this.fullGiftVal!=null){
                    json = {
                        "acvitityParam":[{ids:this.seckillId}],
                        "rows":[{ids:this.cartsId,totalMoney:this.pay_money,remark:'',addressId:'0'}],
                        "logistics":{express:0},
                        platId: this.$platId,
                        promoId: this.gainpromId,
                        virtualMoney: this.discountMoney,
                        fullGift:[{
                            batchno:this.fullGiftVal.batchno,
                            goodsid:this.fullGiftVal.goodsid,
                            qty:this.fullGiftVal.max,
                            nowprice:this.fullGiftVal.price,
                            promotionId:this.fullGiftVal.promotionId,
                            oriprice:this.fullGiftVal.oriprice,
                            supplierId:this.fullGiftVal.supplierId,
                            settlement_price:this.fullGiftVal.settlement_price
                        }],
                        globalPromoIds: this.globalPromId.substring(1),
                        specialPromoIds:this.specialPromId.substring(1),
                    }
                }else{
                    json = {
                        "acvitityParam":[{ids:this.seckillId}],
                        "rows":[{ids:this.cartsId,totalMoney:this.pay_money,remark:'',addressId:'0'}],
                        "logistics":{express:0},
                        platId: this.$platId,
                        promoId: this.gainpromId,
                        virtualMoney: this.discountMoney,
                        globalPromoIds: this.globalPromId.substring(1),
                        specialPromoIds:this.specialPromId.substring(1),
                    }
                }
                this.$post(this.$api.homeCreateOrder ,json).then(res=>{ 
                    if(res.code == 500){
                        this.loading = false;
                        this.fullGiftVal = null;
                        return this.$message.error(res.message);
                    }else{
                        this.loading = false;
                        this.$message.success('订单创建成功，等待支付');
                        if(res.data != undefined){
                            this.orderId = res.data;
                            return this.$router.push('/order/chose_pay/'+this.orderId)
                        }else{
                            return this.$router.push('/user/order')
                        }

                    }

                })
            }else{
                let json = {}
                if(this.tableData.length>0 && this.fullGiftVal!=null){
                    json = {
                    "rows":[{ids:this.cartsId,totalMoney:this.pay_money,remark:'',addressId:'0'}],
                    "logistics":{express:0},
                    platId: this.$platId,
                    promoId: this.gainpromId,
                    virtualMoney: this.discountMoney,
                    fullGift:[{
                        batchno:this.fullGiftVal.batchno,
                        goodsid:this.fullGiftVal.goodsid,
                        qty:this.fullGiftVal.max,
                        nowprice:this.fullGiftVal.price,
                        promotionId:this.fullGiftVal.promotionId,
                        oriprice:this.fullGiftVal.oriprice,
                        supplierId:this.fullGiftVal.supplierId,
                        settlement_price:this.fullGiftVal.settlement_price
                    }],
                    globalPromoIds: this.globalPromId.substring(1),
                    specialPromoIds:this.specialPromId.substring(1),
                }
                }else{
                    json = {
                        "rows":[{ids:this.cartsId,totalMoney:this.pay_money,remark:'',addressId:'0'}],
                        "logistics":{express:0},
                        platId: this.$platId,
                        promoId: this.gainpromId,
                        virtualMoney: this.discountMoney,
                        globalPromoIds: this.globalPromId.substring(1),
                        specialPromoIds:this.specialPromId.substring(1),
                    }
                }
                this.$post(this.$api.homeCreateOrder ,json).then(res=>{ 
                    if(res.code == 500){
                        this.loading = false;
                        this.fullGiftVal = null;
                        return this.$message.error(res.message);
                    }else{
                        this.loading = false;
                        this.$message.success('订单创建成功，等待支付');
                        if(res.data != undefined){
                            this.orderId = res.data;
                            return this.$router.push('/order/chose_pay/'+this.orderId)
                        }else{
                            return this.$router.push('/user/order')
                        }

                    }

                });
            }

        },

        //可用优惠券列表
        getCouponsToOrdersList(){
            this.$post(this.$api.queryDisCountCouponByShopCar,{
                ids:this.cartsId,
                money:this.total_price,
                seckillMoney:this.seckillMoney,
                platId:this.$platId,
                customerId:this.userInfo.company,
            }).then(res=>{
                if(res.data){
                    //全场满减 (注: 满折已由后台计算)
                    if(res.data.autoFull){
                        if(res.data.autoFull.rate > 0){ // 折扣率
                            this.autoRate = res.data.autoFull.rate;
                        } 
                        if(res.data.autoFull.fullMoney > 0){ //面值
                            this.fullMoney = res.data.autoFull.fullMoney;
                        }
                    }
                    //欣币与全场券
                    if(res.data.global){
                        res.data.global.forEach((v,i)=>{
                            if(v.discountId != 6){
                                v.lableText = '满' + v.minfee + '元减' + v.discount + '元，秒杀、专享除外'
                            }else{
                                v.lableText = '满' + v.minfee + '元' + parseFloat(Number((1 - v.discount)*10).toFixed(2)) + '折，秒杀、专享除外'
                            }
                        });
                        //如果有欣币，【默认】优先使用欣币
                        if(res.data.virtual > 0){
                            this.global_list = [];
                            this.special_list = [];
                            this.gainpromId = 0;
                            this.promoId = 0;

                            this.discountMoney = res.data.virtual;
                            this.pay_money = this.total_price - res.data.virtual;
                            this.rate =  res.data.virtualRate;
                            this.virtual_list = res.data.virtual +"|"+res.data.virtualRate;
                            this.virtual_Rate = res.data.virtualRate;
                            
                            //优惠明细
                            this.showVirtualDisCounts = "使用欣币"+res.data.virtual+"个";
                            if(this.autoRate > 0 && this.autoRate < 1){
                                this.showAutoDiscounts = "全场自动满减优惠"+this.fullMoney + "元";
                            }
                            this.showDisCounts = false;
                        }else if(res.data.global.length > 0){
                            this.global_list = [];
                            this.special_list = [];
                            this.gainpromId = 0;
                            this.promoId = 0;

                            //有全场券
                            this.rate = res.data.global[0].rate; //默认获取第一条优惠信息折扣
                            this.global_list.push(0)

                            this.gainpromId = res.data.global[0].gainpromoId;
                            this.promoId = res.data.global[0].promoId;
                            var useCoupon = res.data.global[0].useCoupon;
                            this.globalPromId=","+res.data.global[0].promoId;
                            this.handleTicketCombination(res.data.global, useCoupon, this.promoId, res.data.global[0].sn, 0);//叠加逻辑判断
                            //获取pay_money值
                            if(Number(this.seckillMoney) > 0){
                                this.pay_money = (((this.total_price - Number(this.seckillMoney)) * this.rate) + Number(this.seckillMoney)).toFixed(2);
                            } else {
                                this.pay_money = (this.total_price * this.rate).toFixed(2);
                            }

                            //优惠明细
                            this.showCouponDiscounts = res.data.global[0].lableText;
                            if(this.autoRate > 0 && this.autoRate < 1){
                                this.showAutoDiscounts = "全场自动满减优惠"+this.fullMoney + "元";
                            }
                            this.showDisCounts = false;

                        } else if(this.autoRate > 0 && this.autoRate < 1){
                            //没有优惠券并且没有欣币，但有折扣率则为全场满减
                            this.rate = this.autoRate;
                            
                            //优惠明细
                            this.showAutoDiscounts = "全场自动满减优惠"+this.fullMoney + "元";
                            this.showDisCounts = false;
                        }else{
                            //没有全场券
                            this.virtual_list = [];
                            this.global_list = [];
                            this.special_list = [];
                            this.gainpromId = 0;
                            this.promoId = 0;
                            this.discountMoney = 0;
                            this.showAutoDiscounts = null;
                        }
                    }
                    //专品券
                    if(res.data.special && res.data.special.length > 0){
                        res.data.special.forEach((v,i)=>{
                            if(v.discountId != 6){
                                v.lableText = '满' + v.minfee + '元减' + v.discount + '元，秒杀、专享除外'
                            }else{
                                v.lableText = '满' + v.minfee + '元' + parseFloat(Number((1 - v.discount)*10).toFixed(2)) + '折，秒杀、专享除外'
                            }
                        });
                    }
                    this.couponList = res.data;
                }else{
                    //没有优惠券
                    this.couponList = [];
                    this.special_list = [];
                    this.global_list = [];
                    this.virtual_list = [];
                    this.gainpromId = 0;
                    this.rate = 0;
                    this.discountMoney = 0;
                    this.couponList.virtual = 0;
                }
            }).catch(err=>{
                this.couponList = [];
                this.rate = 0
            })
        },

        //更改购物车输入数量
        handleChange(index,row){
            if(row.qty == undefined){
                this.get_cart_list();
                return this.$message.error('数量不正确');
            }
            this.$post(this.$api.manualAddNum,{
                id:row.id,
                num:row.qty,
                customerId:this.userInfo.company,
                goodsId:row.goodsId,
                promoId:row.promoId,
                platId:this.$platId,
                type:'new1'
            }).then(res=>{
                if(res.code == 200){
                    //页面计算数量，小计
                    this.rate = 0;
                    this.list[index].qty = row.qty;
                    this.list[index].curPrice = row.curPrice;
                    this.list[index].purchaseMoney = Number(row.qty)*Number(row.curPrice).toFixed(2);
                    this.sum_price();
                }else{
                    this.$message.error(res.message);
                    setTimeout(()=>{
                        this.get_cart_list();
                    },100);

                }
            }).catch(err=>{
            })
        },

        //选择全场券
        changeGlobal(item){
            let discount = 0;
            let thisRate = 1;
            var useCoupon = false;
            let pmoney = this.total_price;//初始金额

            this.isGlobalLoading = true; //多选加载
            this.globalRate = 1;//全场券折扣率
            this.globalPromId = '';
            this.markSpecialCoupon = 0;//能否选择专品的标记
            this.globalMarkVirtual = 0;//能否选择欣币的标记

            this.showCouponDiscounts = "";

            //初始化所有全场券
            this.couponList.global.forEach(cou => {
                cou.disabled = false;
                cou.sel = 0;
            })

            if(this.autoRate > 0 && this.autoRate < 1){
                //优惠明细
                this.showAutoDiscounts = "全场自动满减优惠"+this.fullMoney + "元";
                this.showDisCounts = false;
            }

            //获取已选专品是否可以叠加专品
            var useSpecialCoupon = 0;
            this.couponList.special.forEach(cou=>{
                if(cou.sel == 1){
                    useSpecialCoupon = 1
                    if(cou.useSpecialCoupon){
                        useSpecialCoupon = 2
                    }
                }
            })

            item.forEach(index=>{
                var info = this.couponList.global[index];
                this.gainpromId = info.promoId; //优惠券ID
                this.globalPromId += "," + info.promoId;
                thisRate = thisRate * info.rate; //折扣率
                this.discountid = info.discountId; //券标识
                discount = (Number(discount) + Number(info.discount)).toFixed(2);
                useCoupon = info.useCoupon;//全场是否叠加(当前选择的)

                this.handleTicketCombination(this.couponList.global, useCoupon, this.gainpromId, info.sn, useSpecialCoupon);//全场的叠加判断

                //获取折扣率与pay_money值
                this.globalRate = thisRate;//折扣率
                if(this.globalRate != 1){
                    if(this.globalMarkVirtual != 0){//不叠加欣币
                       this.virtual_Rate = 1;
                    } 
                }

                var total_price =  (this.total_price - Number(this.seckillMoney)) * this.globalRate * this.virtual_Rate * this.autoRate;
                var oldSpecialMoney = 0;
                if(this.nowSpecialMoney > 0){
                    oldSpecialMoney =  this.oldSpecialMoney * this.globalRate * this.virtual_Rate * this.autoRate;
                    this.nowSpecialMoney = oldSpecialMoney * this.specialRate;
                }

                if(Number(this.seckillMoney) > 0){
                    this.pay_money = (((total_price - oldSpecialMoney)) + this.nowSpecialMoney + Number(this.seckillMoney)).toFixed(2);
                } else {
                    this.pay_money = (((total_price - oldSpecialMoney)) + this.nowSpecialMoney).toFixed(2);
                }

                this.showCouponDiscounts += info.lableText+'\n';
                this.showDisCounts = false;

            })

            if(this.globalMarkVirtual == 0){//叠加欣币
                this.rate = this.globalRate * this.virtual_Rate;    
            } else {
                this.rate = this.globalRate;
            }
            
            //均未选中，还原折扣率
            if(item.length == 0){
                //此处pay_moeny是为了门槛费判断
                if(this.nowSpecialMoney > 0){
                    this.nowSpecialMoney = this.oldSpecialMoney * this.rate * this.specialRate * this.autoRate;
                }
                if(Number(this.seckillMoney) > 0){
                    this.pay_money = ((((this.total_price - this.oldSpecialMoney - Number(this.seckillMoney))* this.rate * this.autoRate)) + this.nowSpecialMoney + Number(this.seckillMoney)).toFixed(2);
                } else {
                    this.pay_money = (((this.total_price - this.oldSpecialMoney)* this.rate * this.autoRate) + this.nowSpecialMoney).toFixed(2);
                }
                
                //需要判断是否有已选中的专品 并且 有全场券不叠加专品的
                if(useSpecialCoupon == 2){ //叠加专品
                    this.couponList.global.forEach(cou=>{
                        if(!cou.useSpecialCoupon){//叠加专品券
                            cou.disabled = true;
                        }
                    })
                }
                
                this.couponList.special.forEach(cou=>{
                    if(useSpecialCoupon == 2){ //叠加专品
                        if(cou.useSpecialCoupon){//叠加专品券
                            if(cou.sel != 1){
                                if(cou.minfee > this.pay_money){//门槛不够, 并且不是已选专品券
                                    cou.disabled = true;
                                } else{ //门槛够，则可以选择
                                    cou.disabled = false;
                                }
                            }
                        } else { //不叠加专品，直接禁止
                            if(cou.sel != 1){
                                cou.disabled = true;
                            }
                        }
                    } else if(useSpecialCoupon == 1){//有已选中的专品但不叠加专品券
                        if(cou.sel != 1){
                            cou.disabled = true;
                        }
                    } else { //不叠加专品
                        cou.disabled = false;
                    }
                })

            }

            //专品券是否叠加判断(这只是判断了专品)
            this.couponList.special.forEach(cou=>{
                if(item.length > 0){
                    if(this.markSpecialCoupon == 0){
                        if(!cou.useCoupon){//不叠加全场券
                            if(cou.sel != 1){
                                cou.disabled = true;
                            }
                        } else {
                            //有已选中的专品券可叠加专品 并且 当前循环到的券不是选中券 并且 该券不叠加专品
                            if(useSpecialCoupon == 2 && cou.sel != 1 && !cou.useSpecialCoupon){
                                cou.disabled = true;  
                            } else if (useSpecialCoupon == 1 && cou.sel != 1) { //有选中但该券不叠加全场，则除已选中全场其他都禁止选择
                                cou.disabled = true;  
                            } else {
                                cou.disabled = false;
                            }
                        }
                    } else {
                        cou.sel = 0;
                        cou.disabled = true;
                    }
                }
                
            })
            
            //欣币个数重新计算不能用乘过0.9欣币折扣率后的价格来计算
            if(this.nowSpecialMoney > 0){
                this.nowSpecialMoney = this.oldSpecialMoney * this.globalRate * this.specialRate * this.autoRate;
            }
            if(Number(this.seckillMoney) > 0){
                pmoney = ((((this.total_price - this.oldSpecialMoney)* this.globalRate * this.autoRate - Number(this.seckillMoney))) + this.nowSpecialMoney).toFixed(2);
            } else {
                pmoney = (((this.total_price - this.oldSpecialMoney)* this.globalRate * this.autoRate) + this.nowSpecialMoney).toFixed(2);
            }
            //判断欣币是否可叠加
            if(this.globalMarkVirtual == 0){
                //欣币的重新计算 
                let virtual = 0;
                var v_rate = this.couponList.virtualRate;
                if(v_rate > 0){
                    if(this.virtual_list){
                        if(this.virtual_list.length > 0){
                            virtual = (this.virtual_list.split("|")).slice(0)[0];
                        }
                        if(Number(virtual) > 0){ //已选中欣币
                            this.couponList.virtual =  Math.ceil(pmoney * (1-v_rate));
                            virtual =  Math.ceil(pmoney * (1 - v_rate));
                            this.virtual_list = virtual+"|"+v_rate
                        } else { //未选中欣币
                            this.couponList.virtual =  Math.ceil(pmoney * (1 - v_rate));
                            this.discountMoney = 0;
                        }
                    } else { //未选中欣币 并且 不能为空
                        if(this.couponList.virtual > 0 && v_rate){
                            this.couponList.virtual =  Math.ceil(pmoney * (1 - v_rate));
                            this.discountMoney = 0;
                        }
                    }
                }
                
            } else {
                this.virtual_list = null;
                this.discountMoney = 0;
            }

            this.isGlobalLoading = false;
        },
        //全场的叠加判断
        handleTicketCombination(global, useCoupon, promoId, sn, useSpecialCoupon){
            global.forEach(cou => {
                //将相等的优惠券做标记并变为可选
                if(cou.promoId == promoId && cou.sn == sn){
                    cou.sel = 1;//已选择
                    cou.disabled = false;
                }
                //获取是否叠加专品券标记 (因有可能是多张选中，所以需要单独sel==1判断)
                if(cou.sel == 1){
                    if(this.markSpecialCoupon == 0){
                        if(!cou.useSpecialCoupon){ //不可叠加专品
                            this.markSpecialCoupon = 1;
                            this.specialDiscountName = null;//清空优惠明细展示
                        }
                    }
                    //欣币是否叠加还是必须全场与专品分开，否则不好计算专品是否也有不叠加欣币，全场是否也有不叠加欣币
                    if(this.globalMarkVirtual == 0){
                        if(!cou.useVirtulMoney){ //不可叠加欣币
                            this.globalMarkVirtual = 1;
                            this.showVirtualDisCounts = null;//清空优惠明细展示
                        }
                    }
                }
                if(useCoupon){//当前券的叠加
                    if(cou.useCoupon){//所有券的叠加
                        //未做标记的优惠券进行门槛判断，做相应的禁选逻辑
                        if(cou.promoId != this.gainpromId && cou.sel != 1){
                            if(cou.minfee > this.pay_money){
                                cou.disabled = true;
                            }
                        }
                    } else {
                        if(cou.sel != 1){
                            cou.disabled = true;
                        }
                    }
                } else {
                    if(cou.sel != 1){
                        cou.disabled = true;
                    }
                }

                //如果有选择的专品券，则需要判断是否有全场不叠加专品
                if(useSpecialCoupon > 0 && !cou.useSpecialCoupon){
                    cou.disabled = true;
                }
            });
            
            //如果全场有不叠加欣币，则专品直接不叠加欣币
            if(this.specialMarkVirtual == 1){
                this.globalMarkVirtual = 1
            }
            return global;
        },
        //清空全场券
        clearGlobal(){
            this.gainpromId = 0; //优惠券ID
            this.global_list = [];
            this.rate = this.virtual_Rate;
            this.globalRate = 1;
            this.globalPromId='';
            this.showCouponDiscounts = null;
        },

        //选择专品券 (先选全场在选专品  本身不能选欣币 却可以选择了)
        changeSpecial(item){
            let pmoney = this.total_price;//初始金额
            this.specialRate = 1;
            this.nowSpecialMoney = 0;
            this.oldSpecialMoney = 0;
            this.specialPromId = '';
            var useSpecialCoupon = false;
            this.markGlobalCoupon = 0;
            this.specialDiscountName = '';
            this.specialMarkVirtual = 0;

            //初始化所有专品券
            this.couponList.special.forEach(cou => {
                cou.disabled = false;
                cou.sel = 0;
            })

            if(this.autoRate > 0 && this.autoRate < 1){
                //优惠明细
                this.showAutoDiscounts = "全场自动满减优惠"+this.fullMoney + "元";
                this.showDisCounts = false;
            }

            this.rate = this.globalRate;

            //获取已选全场是否可以叠加全场券
            var useCoupon = 0;
            this.couponList.global.forEach(cou=>{
                if(cou.sel == 1){
                    useCoupon = 1
                    if(cou.useCoupon){
                        useCoupon = 2
                    }
                } 
                
            })

            item.forEach(index=>{
                var info = this.couponList.special[index];
                this.gainpromId = info.promoId;  //优惠券ID
                this.specialPromId += ','+info.promoId;//promId
                this.discountid = info.discountId; //专品券标识
                useSpecialCoupon = info.useSpecialCoupon;
                

                //优惠明细 
                this.specialDiscountName += info.lableText+'\n';//优惠明细 (专品)

                this.showDisCounts = false;

                this.specialRate = this.specialRate * info.rate;

                this.carList = info.carList; //专品券商品
                let specialMoney = 0; //默认专品价格
                if(this.carList){
                    for (var i = 0; i < this.list.length; i++) {
                        if (this.carList.indexOf(this.list[i].id) > -1) {
                            this.list[i].isSpecial = 1;
                        }else{
                            this.list[i].isSpecial = 0;
                        }
                    }
                }

                //专品的叠加判断
                this.couponList.special.forEach(cou => {
                    //将相等的优惠券做标记并变为可选
                    if(cou.promoId == this.gainpromId && cou.sn == info.sn){
                        cou.sel = 1;
                        cou.disabled = false;
                    }
                    //获取是否叠加全场券标记 (因有可能是多张选中，所以需要单独sel==1判断)
                    if(cou.sel == 1){
                        if(this.markGlobalCoupon == 0){
                            if(!cou.useCoupon){ //不可叠加全场
                                this.markGlobalCoupon = 1;
                                this.showCouponDiscounts = null;//清空优惠明细展示
                            }
                        }
                        if(this.specialMarkVirtual == 0){
                            if(!cou.useVirtulMoney){ //不可叠加欣币
                                this.specialMarkVirtual = 1;
                                this.showVirtualDisCounts = null;//清空优惠明细展示
                            }
                        }
                    }
                    if(useSpecialCoupon){//当前券的专品叠加

                        if(cou.useSpecialCoupon){//所有券的叠加
                            //未做标记的优惠券进行门槛判断，做相应的禁选逻辑
                            if(cou.promoId != this.gainpromId && cou.sel != 1){
                                if(cou.minfee > this.pay_money){
                                    cou.disabled = true;
                                }
                            }
                        } else {
                            if(cou.sel != 1){
                                cou.disabled = true;
                            }
                        }
                    } else {
                        if(cou.sel != 1){
                            cou.disabled = true;
                        }
                    }

                    //如果有选择的全场券，则需要判断是否有专品不叠加全场
                    if(useCoupon > 0 && !cou.useCoupon){
                        cou.disabled = true;
                    }

                })

                //如果全场有不叠加欣币，则专品直接不叠加欣币
                if(this.globalMarkVirtual == 1){
                    this.specialMarkVirtual = 1
                }


                //计算专品券原价和优惠后价格
                this.list.map((res)=>{
                    if(res.isSpecial == 1 && res.isCheck == true){
                        specialMoney += (res.qty*res.curPrice);
                    }
                });

                if(this.specialMarkVirtual != 0){//不叠加欣币
                  this.virtual_Rate = 1;
                }
                
                this.nowSpecialMoney = specialMoney * this.specialRate * this.rate * this.autoRate * this.virtual_Rate;   //当前专品券券后价
                this.oldSpecialMoney = specialMoney;  //当前专品券原价

                if(Number(this.seckillMoney) > 0){
                    this.pay_money = ((((this.total_price - Number(this.seckillMoney) - this.oldSpecialMoney) * this.rate * this.autoRate * this.virtual_Rate)) + this.nowSpecialMoney + Number(this.seckillMoney)).toFixed(2);
                } else {
                    this.pay_money = (((this.total_price - this.oldSpecialMoney) * this.rate * this.autoRate * this.virtual_Rate) + this.nowSpecialMoney).toFixed(2);
                }
                
            })

            if(this.specialMarkVirtual == 0){//叠加欣币
                this.rate = this.globalRate * this.virtual_Rate;    
            } else {
                this.rate = this.globalRate;
            }
            
            //均未选中，还原折扣率
            if(item.length == 0){
                //此处pay_moeny是为了门槛费判断
                if(this.nowSpecialMoney > 0){
                    this.nowSpecialMoney = this.oldSpecialMoney * this.rate * this.specialRate * this.autoRate;
                }
                if(Number(this.seckillMoney) > 0){
                    this.pay_money = ((((this.total_price - this.oldSpecialMoney - Number(this.seckillMoney))* this.rate * this.autoRate )) + this.nowSpecialMoney + Number(this.seckillMoney)).toFixed(2);
                } else {
                    this.pay_money = (((this.total_price - this.oldSpecialMoney)* this.rate * this.autoRate) + this.nowSpecialMoney).toFixed(2);
                }

                //需要判断是否有已选中的全场券 并且 有专品不叠加全场的
                if(useCoupon == 2){ //叠加全场
                    this.couponList.special.forEach(cou=>{
                        if(!cou.useCoupon){//叠加全场券
                            cou.disabled = true;
                        }
                    })
                }
                
                this.couponList.global.forEach(cou=>{
                    if(useCoupon == 2){//有已选中的全场并且可以叠加全场
                        if(cou.useCoupon){//叠加全场券
                            if(cou.minfee > this.pay_money && cou.sel != 1){//门槛不够, 并且不是已选全场券
                                cou.disabled = true;
                            } else{ //门槛够，则可以选择
                                cou.disabled = false;
                            }
                        } else { //不叠加全场券，直接禁止
                            if(cou.sel != 1){
                                cou.disabled = true;
                            }
                        }
                    } else if(useCoupon == 1){//有已选中的全场但不叠加全场券
                        if(cou.sel != 1){
                            cou.disabled = true;
                        }
                    } else { //不叠加全场券
                        if(cou.sel != 1){
                            cou.disabled = false;
                        }
                    }
                })
            }

            //全场券是否叠加判断
            this.couponList.global.forEach(cou=>{

                if(item.length > 0){
                    if(this.markGlobalCoupon == 0){
                        if(!cou.useSpecialCoupon){//不叠加专品券
                            if(cou.sel != 1){
                                cou.disabled = true;
                            }
                        } else {
                            //有已选中的全场券可叠加全场 并且 当前循环到的券不是选中券 并且 该券不叠加全场
                            if(useCoupon == 2 && cou.sel != 1 && !cou.useCoupon){
                                cou.disabled = true;  
                            } else if (useCoupon == 1 && cou.sel != 1) { //有选中但该券不叠加全场，则除已选中全场其他都禁止选择
                                cou.disabled = true;  
                            } else {
                                cou.disabled = false;
                            }
                        }
                    } else {
                        cou.sel = 0;
                        cou.disabled = true;
                    }
                }

            })


            //欣币个数重新计算不能用乘过0.9欣币折扣率后的价格来计算(因为是重新计算欣币个数，而rate内有欣币的折扣率，所以不能用rate)
            if(this.nowSpecialMoney > 0){
                this.nowSpecialMoney = this.oldSpecialMoney * this.globalRate * this.specialRate * this.autoRate;
            }
            
            if(Number(this.seckillMoney) > 0){
                //计算欣币要减掉秒杀金额 
                pmoney = ((((this.total_price - Number(this.seckillMoney) - this.oldSpecialMoney) * this.globalRate * this.autoRate)) + this.nowSpecialMoney).toFixed(2);
            } else {
                pmoney = (((this.total_price - this.oldSpecialMoney) * this.globalRate  * this.autoRate) + this.nowSpecialMoney).toFixed(2);
            }

            //判断欣币是否可叠加
            if(this.specialMarkVirtual == 0){
                //欣币的重新计算 
                let virtual = 0;
                var v_rate = this.couponList.virtualRate;
                if(v_rate > 0){
                    if(this.virtual_list){
                        if(this.virtual_list.length > 0){
                            virtual = (this.virtual_list.split("|")).slice(0)[0];
                        }
                        if(Number(virtual) > 0){ //已选中欣币
                            this.couponList.virtual =  Math.ceil(pmoney * (1-v_rate));
                            virtual =  Math.ceil(pmoney * (1 - v_rate));
                            this.virtual_list = virtual+"|"+v_rate
                        } else { //未选中欣币
                            this.couponList.virtual =  Math.ceil(pmoney * (1 - v_rate));
                            this.discountMoney = 0;
                        }
                    } else { //未选中欣币 并且 不能为空
                        if(this.couponList.virtual > 0 && v_rate){
                            this.couponList.virtual =  Math.ceil(pmoney * (1 - v_rate));
                            this.discountMoney = 0;
                        }
                    }
                }
                
            } else {
                this.virtual_list = null;
                this.discountMoney = 0;
            }
        },
        //清空专品券
        clearSpecial(){
            this.rate = this.globalRate * this.virtual_Rate;
            this.gainpromId = 0;
            this.special_list = [];
            this.nowSpecialMoney = 0;
            this.oldSpecialMoney = 0;
            this.discountid = 0; //专品券标识
            this.specialPromId = "";
            for (var i = 0; i < this.list.length; i++) {
                this.list[i].isSpecial = 0;
            }

            this.specialDiscountName = null;
        },

    },
    created() {
        this.version = this.$version;
        if(localStorage.getItem('filePath')){
            this.filePath = localStorage.getItem('filePath');
        }else{
            this.filepath();
        }
        if(JSON.parse(localStorage.getItem('userInfo'))){
            this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        }else{
            this.get_user_info();
        }
        this.get_cart_list();
    },
};
</script>
<style lang="scss" scoped>
.cart{
    background: #fff;
        .el-step__icon{
            height: 24.5px !important;
            line-height: 24.5px !important;
        }
}
.join_bzt{
    margin-top:30px;
}
.store_goods_list{
    margin-top: 30px;
    font-size: 14px;
    .store_goods_list_title{
        background: #f5f5f5;
        padding: 10px 20px;
        line-height: 30px;
    }
    .topay{
        background: #40b2ee;
        text-align: center;
        line-height: 36px;
        width: 100px;
        color:#fff;
        border-radius: 3px;
        font-size: 12px;
        cursor: pointer;
    }
    .topay:hover{
        transition: color .2s;
        background: #F56C6C;
    }
    .topay2{
        line-height: 36px;
        text-align: right;
        padding-right: 15px;
        font{
            padding:0 5px;
        }
        span{
            font-size: 18px;
            line-height: 36px;
            color:#40b2ee;
        }
    }
}
.store_goods_all_store_info{
    // margin-top: 20px;
    font-size: 14px;
    // margin-left: 20px;
    // span{
    //     padding:3px 8px;
    //     border:1px solid #40b2ee;
    //     border-radius: 3px;
    //     color:#40b2ee;
    //     margin-left: 15px;
    // }
    ul{
        // margin-top: 20px;
        // margin-right: 20px;
        //border:1px solid #efefef;
        li{
            border-bottom: 1px solid #efefef;
            padding-left: 20px;
            min-height: 90px;
            .el-checkbox{
                margin-top: 35px;
            }
            .goods_thumb{
                margin-top: 25px;
                margin-bottom: 25px;
                float: left;
                margin-right: 20px;
                img{
                    border-radius: 3px;
                }
            }
            .goods_title{
                margin-top: 10px;
                
            }
            .remove{
                color:#40b2ee;
                line-height: 90px;
            }
            .price{
                line-height: 90px;
            }
            .batchno{
                line-height: 90px;
                color:#666;
            }
            .jia,.jian{
                line-height: 30px;
                padding:0 8px;
                color:#666;
                float: left;
                border: 1px solid #efefef;
                margin-top: 30px;
                cursor: pointer;
            }
            .nums{
                // margin:0 10px;
                background: #fff;;
                margin-top: 30px;
                float: left;
                width: 40px;
                input{
                    width: 40px;
                    height: 32px;
                    outline: none;
                    border:1px solid #efefef;
                    border-left: none;
                    border-right: none;
                    padding:0px 5px;
                    box-sizing: border-box;
                    color:#666;
                    text-align: center;
                }
            }
        }
        li a{
            color:#666;
        }
        li a:hover{
            color:#40b2ee;
        }
        li:after{
            content: "";
            display: block;
            clear: both;
        }
    }
}
.store_goods_all_store_info ul li .nums input{
    background: #fff;
}
.separator {
    border-right: 1px solid #666;
    height: 18px;
    width: 2px;;
    margin: 0 20px;
    display: initial;
}

.shopping-link {
    transition: color .2s;
    display: inline;
    cursor: pointer;
}

.shopping-link span.nowPrice{
    font-size: 28px;
    color: #F56C6C;
}

.shopping-link:hover{
    color: #F56C6C;
}

.table-layout {
    margin-top: 10px;
    margin-bottom: 10px;
    border-left: 1px solid #EBEEF5;
    border-top: 1px solid #EBEEF5;
}

.table-cell {
    height: 30px;
    line-height: 30px;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
    font-size: 14px;
    color: #606266;
    text-align: center;
    overflow: hidden;
}

.table-cell p ,el-table-column p{
    line-height: 25px;
}

.table-cell-title {
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
    height: 30px;
    line-height: 30px;
    background: #f5f7fa;
    text-align: center;
    font-size: 14px;
    color: #909399;
}

.el-input-number--mini{
    width: 100px;
}
</style>

<style>
    /* 隐藏全选 */
    .DisableSelection > .cell {
        display: none !important;
    }

    .el-table .warning-row {
        background: rgb(254, 240, 240);
    }

    .el-table .success-row {
        background: #f0f9eb;
    }
</style>